<template>
  <section class="news-section">
    <div class="container">
      <div class="section-header">
        <h2 v-for="(title, index) in info.home_header5" :key="index">
          {{ title }}
        </h2>
        <p v-for="(subtitle, index) in info.home_header5_subtitle" :key="index">
          {{ subtitle }}
        </p>
      </div>
      <div class="news-grid">
        <div class="news-card" v-for="item in news" :key="item.id">
          <div class="news-category">{{ item.category }}</div>
          <h3 class="news-title">
            {{ item.title }}
          </h3>
          <p class="news-date">{{ item.date }}</p>
          <p class="news-excerpt">了解更多关于{{ item.title }}的详细信息...</p>
          <div class="news-link" @click="() => navigateToNews(item.id)">
            阅读更多 →
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { NewsType } from "@/stores/news";
import { useRouter } from "vue-router";
const router = useRouter();

const navigateToNews = (id: number) => {
  router.push(`/newsInfo`);
  localStorage.setItem("newsInfoId", id.toString());
};

interface titleInfoType {
  home_header5?: string[];
  home_header5_subtitle?: string[];
}

interface SectionProps {
  info: titleInfoType;
  news?: NewsType[];
}
withDefaults(defineProps<SectionProps>(), {});
</script>

<style scoped>
/* 内容区域通用样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-header {
  text-align: center;
  margin-bottom: 50px;
}

.section-header h2 {
  font-size: 2.5rem;
  color: #1a5fb4;
  margin-bottom: 15px;
}

.section-header p {
  font-size: 1.1rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
}

/* 新闻动态 */
.news-section {
  padding: 80px 0;
  background-color: white;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.news-card {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 10px;
  transition: transform 0.3s;
  display: flex;
  flex-direction: column;
}

.news-card:hover {
  transform: translateY(-5px);
}

.news-category {
  display: inline-block;
  padding: 5px 15px;
  background: #1a5fb4;
  color: white;
  border-radius: 20px;
  font-size: 0.8rem;
  margin-bottom: 15px;
  align-self: flex-start;
}

.news-title {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  line-height: 1.4;
  margin-bottom: 10px;
  color: #333;
  font-size: 1.1rem;
  min-height: 2.8em;
}

.news-date {
  color: #999;
  font-size: 0.9rem;
  margin-bottom: 15px;
}

.news-excerpt {
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
  flex: 1;
  font-size: 0.9rem;
}

.news-link {
  color: #1a5fb4;
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.95rem;
  margin-top: auto;
}

.news-link:hover {
  text-decoration: underline;
}

/* 平板端适配 - 2列布局 */
@media (max-width: 1024px) {
  .news-section {
    padding: 60px 0;
  }
  
  .news-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
  }
  
  .news-card {
    padding: 22px;
  }
}

/* 移动端适配 - 单列布局 */
@media (max-width: 768px) {
  .news-section {
    padding: 50px 0;
  }
  
  .container {
    padding: 0 15px;
  }
  
  .section-header {
    margin-bottom: 40px;
  }
  
  .section-header h2 {
    font-size: 2rem;
  }
  
  .section-header p {
    font-size: 1rem;
  }
  
  .news-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .news-card {
    padding: 20px;
  }
  
  .news-category {
    font-size: 0.75rem;
    padding: 4px 12px;
  }
  
  .news-title {
    font-size: 1rem;
    margin-bottom: 8px;
  }
  
  .news-date {
    font-size: 0.85rem;
    margin-bottom: 12px;
  }
  
  .news-excerpt {
    font-size: 0.85rem;
    margin-bottom: 12px;
  }
  
  .news-link {
    font-size: 0.9rem;
  }
}

/* 超小屏幕适配 */
@media (max-width: 480px) {
  .news-section {
    padding: 40px 0;
  }
  
  .container {
    padding: 0 10px;
  }
  
  .section-header h2 {
    font-size: 1.6rem;
  }
  
  .news-card {
    padding: 18px;
  }
  
  .news-title {
    font-size: 0.95rem;
  }
}
</style>
